import { Link } from "react-router-dom";
import ProjectCard from "@/components/ProjectCard";
import "@/styles/ProjectsPreview.css";

const ProjectsPreview = ({ projects, loading }) => {
  return (
    <section className="projects-preview section-padding" data-testid="projects-preview">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title" data-testid="preview-title">Proyectos Destacados</h2>
          <div className="title-line"></div>
          <p className="section-description" data-testid="preview-description">
            Conoce algunos de nuestros trabajos más recientes
          </p>
        </div>

        {loading ? (
          <div className="loading-state" data-testid="preview-loading">
            <div className="spinner"></div>
            <p>Cargando proyectos...</p>
          </div>
        ) : projects.length === 0 ? (
          <div className="empty-state" data-testid="preview-empty">
            <p>Próximamente mostraremos nuestros proyectos destacados</p>
          </div>
        ) : (
          <div className="projects-grid" data-testid="preview-grid">
            {projects.slice(0, 3).map((project, index) => (
              <ProjectCard key={project.id} project={project} index={index} />
            ))}
          </div>
        )}

        <div className="preview-cta">
          <Link to="/proyectos" className="view-all-btn" data-testid="view-all-projects-btn">
            Ver Todos los Proyectos
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProjectsPreview;